import { getCache } from '../../../apollo/Cache';
import {
  CoreCategoryFieldsFragment,
  CoreCategoryFieldsFragmentDoc,
  GetBitlyAccountsQuery
} from '../../../models/graphql';

export const mapUtmPatterns = (
  socialProfile: GetBitlyAccountsQuery['workspace']['socialProfiles'][number],
  categoryId: string | null
): { ACCOUNT: string; CATEGORY: string; NETWORK: string } => {
  const ACCOUNT = socialProfile.displayName;
  const cachedCategory = categoryId
    ? getCache().readFragment<CoreCategoryFieldsFragment>({
        id: `Category:${categoryId}`,
        fragment: CoreCategoryFieldsFragmentDoc
      })
    : null;
  const CATEGORY = cachedCategory ? cachedCategory.name : '';
  switch (socialProfile.__typename) {
    case 'FacebookSocialProfile':
      return {
        ACCOUNT,
        CATEGORY,
        NETWORK: 'facebook'
      };
    case 'InstagramSocialProfile':
      return {
        ACCOUNT,
        CATEGORY,
        NETWORK: 'instagram'
      };
    case 'GoogleSocialProfile':
      return {
        ACCOUNT,
        CATEGORY,
        NETWORK: 'google'
      };
    case 'TwitterSocialProfile':
      return {
        ACCOUNT,
        CATEGORY,
        NETWORK: 'twitter'
      };
    case 'LinkedInSocialProfile':
      return {
        ACCOUNT,
        CATEGORY,
        NETWORK: 'linkedin'
      };
    case 'PinterestSocialProfile':
      return {
        ACCOUNT,
        CATEGORY,
        NETWORK: 'pinterest'
      };
    default:
      return {
        ACCOUNT: '',
        CATEGORY,
        NETWORK: ''
      };
  }
};
